<template>
    <!-- Invite accounts for super user page -->
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >          
          <md-dialog-title>
              <span>Create Creative Company</span>
              <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(createCompany)" class="form">
            <div class="form__content">                            
              <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                  <md-field>                        
                    <label>Company name</label>
                    <md-input v-model="company.name" />
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
              </ValidationProvider>   
              <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Client logo</label>
                <div class="md-file">
                  <input readonly="readonly" class="md-input" v-model="fileNamesToUpload"/>
                  <input type="file" accept="image/*" @change="filesSelected"/>
                </div>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>                      
            </div>
            <md-dialog-actions>
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                </div>
                {{ error }}
                <div class="md-layout-item text-right">
                 <md-button class="md-primary modal-save-btn" type="submit">Create Creative Company</md-button>
                </div>
              </div>
            </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>
        
        <button class="md-button btn newClientButton md-theme-default" @click="showDialog = true">
            <img alt="Add Button" class="addButton" src="@/assets/img/icons/addButton.svg" />
            create creative company
        </button>
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "The field is required."
});

export default {
  
  mixins: [apiHandlerMI],
  data(){
    return{
      showDialog: false,
      active: false,
      type: 'square',
      needUpload: false,
      filesToUpload: null,
      fileNamesToUpload: undefined,
      company: {
        name: '',
      },
      error: {},      
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
    methods:{
    filesSelected(event) {
      this.needUpload = true;
      this.filesToUpload = event.target.files;
      this.fileNamesToUpload = this.filesToUpload[0].name
    },
    upload_selected: function (num = 0) {
      if (!this.needUpload)
        return false;
      const _this = this;
      if (!(this.filesToUpload || []).length) {

        this.error.logo = "Image required!";
        this.$forceUpdate();
        return;
      }
     
      if (!this.type) {
        this.error.logo = "Type required!";
        this.$forceUpdate();
        return;
      }
      this.error.logo = undefined;
      if (this.filesToUpload.length <= num) {
        this.fileNamesToUpload = undefined;
        //this.uploadSuccess = `You have successfully uploaded ${num} files`;
        setTimeout(() => {
          _this.uploadSuccess = undefined;
        }, 3000);
        return;
      }

      let file = this.filesToUpload[num];

      const formData = new FormData();
      formData.append("files[0]", file);
      formData.append('payment_cluster_id',this.$store.state.user.main_payment_cluster)
      formData.append("folder", 'client');
      formData.append("upload_type", this.type);

      var url = "image";
      if (this.filesToUpload[num].type == "application/pdf") url = "document";
      //console.log("start_upload");
      this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function (resp) {
            _this.needUpload = false;
            _this.company.logo = resp.data.images[0].id;
            _this.createCompanyData();
            //_this.upload_selected(num + 1);
          }
      );
    },
        
    createCompany() {
        console.log('createCompany',this.needUpload);
      if (this.needUpload)
        this.upload_selected();
      else {
        this.createCompanyData()
      }

    },
      createCompanyData(){
        var _this = this;
        this.company.payment_cluster_id = this.$store.state.user.client[0].payment_cluster_id;
        
        _this.post('/usermanager/create_creative_company',this.company,{},function(){
            
            _this.$parent.refreshCreativeCompany();
            _this.showDialog = false;
               
            },function(){
            alert('Valami nem sikerült ellenőrizd az adatokat!');
        })
      },
      
      cancel(){
        this.showDialog = false        
      }
    }
 }

</script>